export const singularSpecifications = [
  {
    title: "Air Pod: Postless",
    specs: {
      technicalDetails: {
        label: "Technical Details",
        keyPoints: [
          "Capacities: <ul><li>0.5mL – 1.0mL (same pod)</li><li>2.0mL</li><li>3.0mL</li><li>4.0mL – 5mL (same pod)</li></ul>",
          "2.6 ohms",
        ],
      },
      construction: {
        label: "Construction",
        keyPoints: [
          "Postless design",
          "BPA-free thermoplastic tank",
          "Proprietary ACTIVE ceramic cottonless atomizer for smooth, even heating",
          "Heavy-metals compliant",
          "ACTIVE® AC3 ultra robust postless core for big clouds",
        ],
      },
      customization: {
        label: "Customization",
        keyPoints: [
          "Stock colors: black and white",
          "Customizable with distinctive finish options",
        ],
      },
      automation: {
        label: "Automation",
        keyPoints: [
          "Pre-racked in 25 unit trays for automation out the box",
          "Suitable for large scale and non-automated operations",
          "Compatible with leading filling & capping platforms",
          "Non-refillable once capped",
        ],
      },
    },
  },
  {
    title: "Pro Pod: Ceramic",
    specs: {
      technicalDetails: {
        label: "Technical Details",
        keyPoints: [
          "Capacity: 0.5mL - 1.0mL (same pod)",
          "1.4 ohms",
          "1.7mm aperture",
        ],
      },
      construction: {
        label: "Construction",
        keyPoints: [
          "Zirconia ceramic center post",
          "BPA-free thermoplastic tank",
          "Heavy-metals compliant",
          "ACTIVE® AC1 connoisseur core for a harmonious balance between flavor and cloud",
        ],
      },
      customization: {
        label: "Customization",
        keyPoints: [
          "Stock colors: black and white",
          "Customizable with distinctive finish options",
        ],
      },
      automation: {
        label: "Automation",
        keyPoints: [
          "Pre-racked in 25 unit trays for automation out the box",
          "Suitable for large scale and non-automated operations",
          "Compatible with leading filling & capping platforms",
          "Non-refillable once capped",
        ],
      },
    },
  },
  {
    title: "Classic Pod: Stainless",
    specs: {
      technicalDetails: {
        label: "Technical Details",
        keyPoints: [
          "Capacities: <ul><li>0.5mL – 1.0mL (same pod)</li><li>2.0mL</li><li>3.0mL</li><li>4.0mL – 5mL (same pod)</li></ul>",
          "1.4 ohms",
          // "2.0mm aperture for various oil viscosities",
        ],
      },
      construction: {
        label: "Construction",
        keyPoints: [
          "BPA-free thermoplastic tank",
          "Heavy-metals compliant",
          "ACTIVE® AC2 core for robust clouds and true-to-strain flavor",
        ],
      },
      customization: {
        label: "Customization",
        keyPoints: [
          "Stock colors: black and white",
          "Customizable with distinctive finish options",
        ],
      },
      automation: {
        label: "Automation",
        keyPoints: [
          "Pre-racked in 25 unit trays for automation out the box",
          "Suitable for large scale and non-automated operations",
          "Compatible with leading filling & capping platforms",
          "Non-refillable once capped",
        ],
      },
    },
  },
  {
    title: "Singular Axil S1 Battery",
    specs: {
      activation: {
        label: "Activation",
        keyPoints: ["Draw activated without complex buttons"],
      },
      features: {
        label: "Features",
        keyPoints: [
          "Magnetic pod connection",
          "Gentle preheat for thick extracts or cold climates at 1.5V for 5 seconds",
          "Compatible with all Singular pods",
        ],
      },
      flavorSettings: {
        label: "Flavor settings",
        keyPoints: [
          "Multiple flavor and vapor settings for different extracts <br/><ul><li>Low: 2.6v for flavor and terpenes</li><li>Medium: 3.0v for a well-rounded experience</li><li>High: 3.4v for big clouds</li></ul>",
        ],
      },
      construction: {
        label: "Construction",
        keyPoints: [
          "Anodized aluminum body",
          "Short circuit and overcharge protection",
          "Grade A, 340 mAh lithium-ion battery",
          "USB-C rechargeable<br/><br/>Note: Do not use power chargers that output more than 5 volts, these may damage the battery.",
        ],
      },
      customization: {
        label: "Customization",
        keyPoints: [
          "Stock colors: black and white",
          "Fully customizable with distinctive finish options",
        ],
      },
    },
  },
  {
    title: "Singular Offset S1 Battery",
    specs: {
      activation: {
        label: "Activation",
        keyPoints: ["Draw activated without complex buttons"],
      },
      features: {
        label: "Features",
        keyPoints: [
          "Magnetic pod connection",
          "Digital Display screen with voltage and battery life",
          "Gentle preheat for thick extracts or cold climates at 1.5V for 5 seconds",
          "Compatible with all Singular pods",
        ],
      },
      flavorSettings: {
        label: "Flavor settings",
        keyPoints: [
          "Multiple flavor and vapor settings for different extracts <br/><ul><li>Low: 2.6v for flavor and terpenes</li><li>Medium: 3.0v for a well-rounded experience</li><li>High: 3.4v for big clouds</li></ul>",
        ],
      },
      construction: {
        label: "Construction",
        keyPoints: [
          "Polycarbonate shell and body",
          "Short circuit and overcharge protection",
          "Grade A, 340 mAh lithium-ion battery",
          "USB-C rechargeable<br/><br/>Note: Do not use power chargers that output more than 5 volts, these may damage the battery.",
        ],
      },
      customization: {
        label: "Customization",
        keyPoints: [
          "Stock colors: black and white",
          "Fully customizable with distinctive finish options",
        ],
      },
    },
  },
];
